import React, { Component } from 'react'
import Checkbox from '../../../../Util/Checkbox/Checkbox'
import DropDown from '../../../../Util/DropDown/DropDown'
import './AdminFilters.css'
import { motion } from 'framer-motion'
import { backdropTransition, popupTransition, transitionDuration } from '../../../../Util/PageTransitions'

export default class AdminFilters extends Component {
    constructor(props) {
        super(props)
        this.state = {
            minimumItemQuantities: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
            minimumOrderPrices: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
            minimumTimesOrderedAmounts: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
            selectedItemQuantity: this.props.filters.selectedItemQuantity,
            minimumOrderPriceSelected: this.props.filters.minimumOrderPriceSelected,
            minimumTimesOrdered: this.props.filters.minimumTimesOrdered,
            selectedTimesOrderedAmount: this.props.filters.selectedTimesOrderedAmount,
            itemsPurchased: this.props.filters.itemsPurchased,
            delivery: this.props.filters.delivery,
            pickup: this.props.filters.pickup,
            minimumItemQuantity: this.props.filters.minimumItemQuantity,
            minimumOrderPrice: this.props.filters.minimumOrderPrice,
            menu: [],
            continuousMenu: [],
        }
    }

    componentDidMount() {
        this.getMenuHandler()
    }

    updateItemPurchasedHandler = (index) => {
        let itemsPurchased = [...this.state.itemsPurchased]
        itemsPurchased[index].selected = !itemsPurchased[index].selected
        this.setState({ itemsPurchased })
    }

    updateItemHandler = (index, newItem) => {
        let itemsPurchased = [...this.state.itemsPurchased]
        itemsPurchased[index].selectedItemIndex = newItem
        this.setState({itemsPurchased})
    }

    addItemHandler = () => {
        let itemsPurchased = [...this.state.itemsPurchased]
        itemsPurchased.push({selected: true, selectedItemIndex: 0})
        this.setState({itemsPurchased})
    }

    getMenuHandler = () => {
        let temp = []
        this.props.menu.forEach((section, sectionIndex) => {
            section.menuItem.forEach((item, itemIndex) => temp.push(item.name))
        })
        this.setState({continuousMenu: temp})
    }

    confirmFilterHandler = () => {
        this.props.displayFiltersHandler()
        this.props.updateFiltersHandler({
            delivery: this.state.delivery,
            pickup: this.state.pickup,
            minimumItemQuantity: this.state.minimumItemQuantity,
            minimumOrderPrice: this.state.minimumOrderPrice,
            itemsPurchased: this.state.itemsPurchased,
            minimumOrderPriceSelected: this.state.minimumOrderPriceSelected,
            selectedItemQuantity: this.state.selectedItemQuantity,
            continuousMenu: this.state.continuousMenu,
            minimumTimesOrdered: this.state.minimumTimesOrdered,
            selectedTimesOrderedAmount: this.state.selectedTimesOrderedAmount
        })
    }

    render() {
        return (
            <motion.div className='adminFiltersPageContainer' initial={backdropTransition.initial} animate={backdropTransition.in} exit={backdropTransition.out} transition={{ duration: transitionDuration }}>
                <div className='adminFiltersPageBackdrop' onClick={this.props.displayFiltersHandler}/>
                <motion.div className='adminFiltersPagePopupContainer' initial={popupTransition.initial} animate={popupTransition.in} exit={popupTransition.out} transition={{ duration: transitionDuration }}>
                    <div className='adminFiltersPagePopupHeader'>
                        <h2 className='adminFiltersPagePopupHeaderText'>Filter</h2>
                        <button className='adminFiltersPagePopupHeaderCloseButton' onClick={this.props.displayFiltersHandler}>&#10005;</button>
                    </div>
                    <div className='adminFiltersPagePopupBodyContainer'>
                        <div className='adminFiltersPageFilterOptionContainer'>
                            <Checkbox onMouseDown={() => this.setState({delivery: !this.state.delivery, pickup: false})} checked={this.state.delivery}/>
                            <p className='adminFilterOptionText'>Delivery</p>
                        </div>
                        <div className='adminFiltersPageFilterOptionContainer'>
                            <Checkbox onMouseDown={() => this.setState({pickup: !this.state.pickup, delivery: false})} checked={this.state.pickup}/>
                            <p className='adminFilterOptionText'>Pickup</p>
                        </div>
                        <div className='adminFiltersPageFilterOptionContainer'>
                            <Checkbox onMouseDown={() => this.setState({minimumItemQuantity: !this.state.minimumItemQuantity})} checked={this.state.minimumItemQuantity}/>
                            <p className='adminFilterOptionText'>Minimum Item Quantity</p>
                            <DropDown items={this.state.minimumItemQuantities} width={150} itemSelected={this.state.selectedItemQuantity} changeOption={(index) => this.setState({selectedItemQuantity: index})}/>
                        </div>
                        <div className='adminFiltersPageFilterOptionContainer'>
                            <Checkbox onMouseDown={() => this.setState({minimumTimesOrdered: !this.state.minimumTimesOrdered})} checked={this.state.minimumTimesOrdered}/>
                            <p className='adminFilterOptionText'>Minimum Times Ordered</p>
                            <DropDown items={this.state.minimumTimesOrderedAmounts} width={150} itemSelected={this.state.selectedTimesOrderedAmount} changeOption={(index) => this.setState({selectedTimesOrderedAmount: index})}/>
                        </div>
                        <div className='adminFiltersPageFilterOptionContainer'>
                            <Checkbox onMouseDown={() => this.setState({minimumOrderPrice: !this.state.minimumOrderPrice})} checked={this.state.minimumOrderPrice}/>
                            <p className='adminFilterOptionText'>Minimum Order Price</p>
                            <DropDown items={this.state.minimumOrderPrices.map((value) => `$${value}`)} width={150} itemSelected={this.state.minimumOrderPriceSelected} changeOption={(index) => this.setState({minimumOrderPriceSelected: index})}/>
                        </div>
                        {this.state.itemsPurchased.map((value, index) => (
                            <div className='adminFiltersPageFilterOptionContainer' key={index}>
                                <Checkbox onMouseDown={() => this.updateItemPurchasedHandler(index)} checked={this.state.itemsPurchased[index].selected}/>
                                <p className='adminFilterOptionText'>Item Purchased</p>
                                <DropDown items={this.state.continuousMenu} customClass={'adminFilterPageItemsPurchasedDropdown'} itemSelected={this.state.itemsPurchased[index].selectedItemIndex} changeOption={(newItem) => this.updateItemHandler(index, newItem)}/>
                                { index === this.state.itemsPurchased.length - 1 && <button className='adminFiltersPageFilterOptionButton primaryButton' onClick={this.addItemHandler}>Add Another Item</button>}
                            </div>
                        ))}
                    </div>
                    <div className='adminFiltersPagePopupFooterContainer'>
                        <button className='adminFiltersPagePopupFooterButton secondaryButton' onClick={this.props.displayFiltersHandler}>Cancel</button>
                        <button className='adminFiltersPagePopupFooterButton primaryButton' onClick={this.confirmFilterHandler}>Filter</button>
                    </div>
                </motion.div>
            </motion.div>
        )
    }
}
